<template>
  
    <div style="margin-bottom: 10px;">
      <div class="d-flex align-items-start justify-content-center" style="height: 50vh;">
        <b-card cols="12" class="w-100" >
          <b-col cols="12" class="mb-2">
            
          </b-col>
  
          <template v-if="cirugia && cirugia.length > 0">
            <b-col md="12" v-for="item in cirugia" :key="item.id">
              
              <b-form-group>
                <i class="fas fa-barcode" style="margin-right: 10px;"></i>
                <span>Codigo: {{ item.codigo }}</span>
              </b-form-group>
              <b-form-group>
                <i class="fas fa-tag" style="margin-right: 10px;"></i>
                <span>Nombre: {{ item.nombre }}</span>
              </b-form-group>
              <b-form-group>
                <i class="fas fa-dollar-sign" style="margin-right: 10px;"></i>
                <span>Precio Doctor: {{ item.precioDoctor }}</span>
              </b-form-group>
              <b-form-group>
                <i class="fas fa-dollar-sign" style="margin-right: 10px;"></i>
                <span>Precio Anestesiologo: {{ item.precioAnestesiologo }}</span>
              </b-form-group>
              <b-form-group>
                <i class="fas fa-hospital" style="margin-right: 10px;"></i>
                <span>Establecimiento : {{ item.establecimiento.Descripcion }}</span>
              </b-form-group>
              <b-form-group>
                <i class="fas fa-briefcase-medical" style="margin-right: 10px;"></i>
                <span>Especialidad : {{ item.especialidad.descripcion }}</span>
              </b-form-group>
              <b-form-group>
                <i class="fas fa-toggle-on" style="margin-right: 10px;"></i>
                <span>Estado : {{ item.estado }}</span>
              </b-form-group>
            </b-col>
          </template>
          <template v-else>
            <b-col md="12">
              <p>No se encontraron cirugias.</p>
            </b-col>
          </template>
        </b-card>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import rutas from '@/assets/utils/rutas.json';
  import { BContainer, BRow, BCol, BCard, BForm, BFormGroup, BFormInput } from 'bootstrap-vue';
  
  export default {
    components: {
      BContainer,
      BRow,
      BCol,
      BCard,
      BForm,
      BFormGroup,
      BFormInput,
    },
    props: ['token'],
    data() {
      return {
        cirugia: [],
      };
    },
    created() {
      const token = this.token;
      this.fetchCirugia(token);
      console.log(token)
    },
    methods: {
      async fetchCirugia(token) {
        const query = `
        query obtenerCirugia($token: String!) {
                allCirugiasMedicas(tokencirugia: $token) {
                    total
                    status
                    message
                    cirugiasMedicas {
                        id
                      	token
                        nombre
                        codigo
                        estado
                      usuarioCreador{
                        id
                        username
                      }
                      precioDoctor
                      precioAnestesiologo
                      especialidad{
                        id
                        descripcion
                      }
                        establecimiento {
                            id
                            Descripcion
                        }
                    }
    								
                    pageInfo {
                        currentPage      
                        totalPages
                        hasNextPage
                        hasPreviousPage
                    }
                }
            }
        `;
  
        const variables = { token: token };
  
        try {
          const response = await axios.post(rutas.axios + 'api', { query, variables });
          if (response.data.data.allCirugiasMedicas.status === 'Success') {
            this.cirugia = response.data.data.allCirugiasMedicas.cirugiasMedicas;
          } else {
            console.error("Error al obtener la cirugia:", response.data.message);
          }
        } catch (error) {
          console.error("Error al realizar la consulta GraphQL:", error);
        }
      }
    }
  };
  </script>
  